var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAloneMarginBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1641387458724,
    fill: "#BFBFBF",
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 25746,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.8 478.72l211.2 211.2 211.2-211.2 60.373333 60.373333L512 810.666667 240.426667 539.093333zM768 298.666667v-85.333334H256v85.333334z",
    "p-id": 25747
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAloneMarginBottom);
export default __webpack_public_path__ + "static/media/alone-margin-bottom.7f9693beff246abc330bec213209db51.svg";
export { ForwardRef as ReactComponent };